<template>
	<div class="processedDetail">
		<el-dialog :title="$t('processed.cargoflow')" :visible.sync="dialogVisible" width="30%">
			<div>
				<el-form ref="form" :model="DxsObjParams" label-width="80px">
					<div v-for="(item, index) in  DxsObjParams.items " :key="index">
						<el-form-item :label="$t('processed.Thesellernote')">
							<span>{{ item.msgToStore }}</span>
						</el-form-item>

						<el-form-item :label="$t('processed.Chooselogistics')" :prop="`items[${index}].ruleId`" :rules="[
							{ required: true, message: $t('processed.selectlogistics'), trigger: 'blur' },]">
							<el-select v-model="item.ruleId" :placeholder="$t('processed.Chooselogistics')">
								<el-option v-for=" itemChild  in  item.logisticsOption " :key="itemChild.ruleId"
									:label="itemChild.logisticsName" :value="itemChild.ruleId">
								</el-option>
							</el-select>
						</el-form-item>
						<el-form-item :label="$t('processed.bulk')">
							<el-col :span="6">
								<el-form-item :prop="`items[${index}].length`" :rules="[
									{ required: true, message: $t('processed.enterlength'), trigger: 'blur' },]">
									<el-input style="width:100px;margin-right:10px" v-model="item.length"
										:placeholder="$t('processed.length')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :prop="`items[${index}].width`" :rules="[
									{ required: true, message: $t('processed.enterwidth'), trigger: 'blur' },]">
									<el-input style="width:100px;margin-right:10px" v-model="item.width"
										:placeholder="$t('processed.width')"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="6">
								<el-form-item :prop="`items[${index}].height`" :rules="[
									{ required: true, message: $t('processed.enterheight'), trigger: 'blur' },]">
									<el-input style="width:100px;margin-right:10px" v-model="item.height"
										:placeholder="$t('processed.height')"></el-input>
								</el-form-item>
							</el-col>
						</el-form-item>
						<el-form-item :label="$t('processed.weight')" :prop="`items[${index}].weight`" :rules="[
							{ required: true, message: $t('processed.enterweight'), trigger: 'blur' },
						]">
							<el-input v-model="item.weight"></el-input>
						</el-form-item>

						<el-form-item :label="$t('processed.actualfreight')">
							<el-input v-model="item.actualCost"></el-input>
						</el-form-item>
						<el-form-item :label="$t('processed.waybillnumber')">
							<el-input v-model="item.trackingNo"></el-input>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">{{ $t('processed.cancel') }}</el-button>
				<el-button type="primary" @click="generateLogisticOrder()">{{ $t('processed.confirm') }}</el-button>
			</span>
		</el-dialog>
		<div style="font-size: 24px;margin-bottom: 20px;font-weight: bold;">{{ $t('processed.Scanningoutbound') }}</div>
		<div class="IdScaneArea">
			<el-input size="mini" v-model="scanNum" :placeholder="$t('processed.Orderarea')"
				@change="packBageOutCopy()" clearable>
			</el-input>
		</div>
		<div class="ppo">
			<div class="ppo-item">{{ $t('processed.Dateofpackaging') }}：{{ packTime }}</div>
			<div class="ppo-item">{{ $t('processed.outboundorders') }}：{{ processedList.length }}</div>
			<div class="ppo-item">
				<el-switch v-model="modelType" @change="judgeGoodsType()" active-color="#E6A23C" inactive-color="#67C23A"
					:active-text="$t('other.a880')" :inactive-text="$t('other.a881')">
				</el-switch>
			</div>
		</div>
		<el-table ref="multipleTable" :data="processedList" tooltip-effect="dark" border
			style="width: 100%;margin-bottom: 50px;" select-all="checkedall" @selection-change="handleSelectionChange">
			<el-table-column type="selection" width="59">
			</el-table-column>
			<el-table-column label="order ID">
				<template slot-scope="scope">
					<div class="ordersn-box">
						<el-tooltip v-show="scope.row.amend" effect="light" :content="$t('processed.Themodified')"
							placement="bottom">
							<i class="iconfont icon-sign"></i>
						</el-tooltip>
						<span>{{ scope.row.orderId }}</span>
					</div>
					<div class="ordersn-box">{{ scope.row.orderStatus }}</div>
					<div class="ordersn-box">{{ scope.row.shopId }}</div>
				</template>
			</el-table-column>
			<el-table-column label="Product(s)" width="250">
				<template slot-scope="scope">
					<span v-for="( item, index ) in  scope.row.items  " :key="index">
						<el-tooltip placement="right">
							<div slot="content">
								<div style="display: flex; color: #FFFFFF;align-items: center;">
									<span style="display: inline-block;width: 80px;height: 80px;margin-right: 20px;">
										<img :src="item.attributeImage ? item.attributeImage : item.image" />
									</span>
									<span>
										<div style="padding:5px 0px;font-size:15px">Product ID：{{ item.itemId }} <el-button
												style="margin-left:10px" size="mini" type="primary"
												@click="CopyText(item.itemId)">Copy</el-button></div>
										<div style="padding:5px 0px;font-size:15px">Name：{{ item.itemName }}</div>
										<div style="padding:5px 0px;font-size:15px">Variation name：{{ item.variationName }}
										</div>
										<div style="padding:5px 0px;font-size:15px">Parent SKU：{{ item.itemSku }}<el-button
												v-show="item.itemSku" style="margin-left:10px" size="mini" type="primary"
												@click="CopyText(item.itemSku)">Copy</el-button></div>
										<div style="margin-top: 5px;font-size:15px">SKU：{{ item.variationSku }}<el-button
												v-show="item.variationSku" style="margin-left:10px" size="mini"
												type="primary" @click="CopyText(item.variationSku)">Copy</el-button></div>
									</span>
								</div>
							</div>
							<span class="pic-wrapper">
								<img style="width: 100%;" :src="item.attributeImage ? item.attributeImage : item.image" />
								<span class="pic-wrapper-quantity">{{ item.variationQuantityPurchased }}</span>
							</span>
						</el-tooltip>
					</span>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="Buyer" show-overflow-tooltip>
				<template slot-scope="scope">
					<div class="ordersn-box">{{ scope.row.buyerName }}</div>
				</template>
			</el-table-column>
			<el-table-column prop="address" label="Tracking" show-overflow-tooltip>
				<template slot-scope="scope">
					<div class="ordersn-box">{{ scope.row.logistics }}</div>
					<div class="ordersn-box">{{ scope.row.trackingNo }}</div>
				</template>
			</el-table-column>
		</el-table>
	</div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { JudegeBindStore, JudegeSensitive } from '../../../utils/toolFun'
import newOrders from '../../../api/moudles/newOrders'
import ordersApi from '../../../api/moudles/order'
import utils from '../../../utils/utils.js'
import Loading from '../../../components/loading.vue'
import order from '../../../api/moudles/order'
import jsonp from '../../../api/jsonp'
export default {
	data() {
		return {
			tableList: [],
			shopInfo: null,
			dialogVisible: false,
			textarea: '',
			scanNum: '',
			packTime: null,
			shopee: null,
			logisticsOption: [],
			DxsObjParams: {
				items: [],
				// height: null,
				// length: null,
				// orderId: null,
				// shopId: null,
				// storeId: null,
				// userId: null,
				// weight: null,
				// width: null,
				// ruleId: null,
				// actualCost: null,
				// imgUrls: null,
				// trackingNo: null,
			},
			rules: {
				// height: [
				// 	{ required: true, message: this.$t("processed.enterheight"), trigger: 'blur' },
				// ],
				// length: [
				// 	{ required: true, message: this.$t("processed.enterlength"), trigger: 'blur' },
				// ],
				// width: [
				// 	{ required: true, message: this.$t("processed.enterwidth"), trigger: 'blur' },
				// ],
				// ruleId: [
				// 	{ required: true, message: this.$t("processed.selectlogistics"), trigger: 'blur' },
				// ],
				// weight: [
				// 	{ required: true, message: this.$t("processed.enterweight"), trigger: 'blur' },
				// ],
			},
			modelType: false
		}
	},
	comments: {

	},
	computed: {

		...mapState({
			userId: state => state.login.userInfo.userId || '',
			processedList: state => state.processed.processedList

		}),

	},
	watch: {

	},
	created() {
		this.modelType = JSON.parse(localStorage.getItem('userInfo')).sensitive
		this.hfkf()
	},
	methods: {
		...mapActions('processed', [
			'getProcessedOrderSn',
			'getProcessedOrderInfo',
			'getIDacountProcessedList',
			'getPackagedOrderByStore',//仓库帐号下猎取已出库出库的订单
			'setPackaged',
			'setPackagedCopy',
			'getProcessedOrders',
			'getLogisticsBystore',
			'getLogisticsByseller',
			'getProcessedOrderBySeller',
			'getProcessedOrderByStore'
		]),

		judgeGoodsType() {
			this.scanNum = null
			console.log(this.modelType)
			this.changePackageType({
				userId: this.userId,
				sensitive: this.modelType
			})
		},

		changePackageType(params) {
			newOrders
				.fixedUserSensitiveType(params)
				.then(res => {
					if (res.code === 200) {
						console.log('desc', res.data)
						if (params.sensitive) {
							this.$message.success(this.$t("other.a882"))
						} else {
							this.$message.warning(this.$t("other.a883"))
						}
						let obj = JSON.parse(localStorage.getItem('userInfo'))
						obj.sensitive = params.sensitive
						localStorage.setItem('userInfo', JSON.stringify(obj))
					} else {
						this.$message.warning(res.msg)
					}
				})

		},
		warningTip(text) {
			this.$confirm(text, this.$t("other.a142"), {
				confirmButtonText: this.$t("other.a884"),
				cancelButtonText: this.$t('other.a146'),
				type: 'warning'
			})
				.then(() => { })
				.catch(() => { })
		},

		generateLogisticOrder() {


			this.$refs.form.validate((valid) => {
				if (valid) {
					console.log(this.DxsObjParams)
					for (let i = 0; i < this.DxsObjParams.items.length; i++) {
						let data = JSON.parse(JSON.stringify(this.DxsObjParams.items[i]))
						data.height = Number(data.height)
						data.length = Number(data.length)
						data.weight = Number(data.weight)
						data.width = Number(data.width)
						data.actualCost = Number(data.actualCost)
						data.trackingNo = Number(data.trackingNo)
						console.log(data,'===>data')
						newOrders
							.createDxsLogisticsOrder(data)
							.then(res => {
								if (res.code === 200) {
									console.log('desc', res.data)
									if (i == this.DxsObjParams.length - 1) {
										this.$message.success(this.$t("processed.Logisticsdelivery"))
										this.dialogVisible = false
									}
								} else {
									this.$message.warning(res.msg)
								}
							})
					}
					// this.DxsObjParams.height = Number(this.DxsObjParams.height)
					// this.DxsObjParams.length = Number(this.DxsObjParams.length)
					// this.DxsObjParams.weight = Number(this.DxsObjParams.weight)
					// this.DxsObjParams.width = Number(this.DxsObjParams.width)
					// this.DxsObjParams.actualCost = Number(this.DxsObjParams.actualCost)
					// this.DxsObjParams.trackingNo = Number(this.DxsObjParams.trackingNo)

					// console.log(this.DxsObjParams)

					// newOrders
					// 	.createDxsLogisticsOrder(this.DxsObjParams)
					// 	.then(res => {
					// 		if (res.code === 200) {
					// 			console.log('desc', res.data)
					// 			this.$message.success(this.$t("processed.Logisticsdelivery"))
					// 			this.dialogVisible = false
					// 		} else {
					// 			this.$message.warning(res.msg)
					// 		}
					// 	})


				} else {
					this.$message.warning(this.$t("processed.redasterisk"))
					return false;
				}
			});
		},

		//出库前先查询订单信息
		getOrderInfo(params) {
			return new Promise((resolve) => {
				this.showLoading()
				ordersApi
					.queryAllOrders({
						end: null,
						hasStoreItem: true,
						offset: 50,
						orderId: params,
						orderType: -1,
						page: 0,
						partnerId: null,
						platform: "",
						shopIds: [],
						sortType: 0,
						start: null,
						storeIds: JSON.parse(localStorage.getItem('userInfo')).storeIds,
						userId: this.userId,

					})
					.then(res => {
						if (res.code === 200) {
							console.log('desc', res.data)
							resolve(res.data.orders[0])
						} else {
							this.$message.warning(res.msg)
						}
					})

			})
		},


		packBageOutCopy() {
			console.log('this', this.scanNum)

			if (this.scanNum) {
				// this.scanNum=this.scanNum.replace(/\s*/g,"")
				// this.setPackagedCopy({ orderId: this.scanNum, userId: this.userId, sensitive: this.modelType }).then(res => {
				// 		if (res.code === 1500) {
				// 			console.log(res)
				// 			this.logisticsOption = res.data.rules
				// 			this.dialogVisible = true
				// 			this.DxsObjParams.shopId = res.data.order.shopId
				// 			this.DxsObjParams.storeId = res.data.order.storeId
				// 			this.DxsObjParams.orderId = res.data.order.orderId
				// 			this.DxsObjParams.msgToStore = res.data.order.msgToStore ? res.data.order.msgToStore : this.$t("processed.remarkspresent")
				// 			this.DxsObjParams.ruleId = Number(res.data.order.messageToSeller)
				// 			this.DxsObjParams.userId = this.userId
				// 		} else {
				// 			this.$confirm(res.msg + this.$t("processed.details"), this.$t("processed.hint"), {
				// 				confirmButtonText: this.$t("processed.Isee"),
				// 				type: 'warning'
				// 			}).then(() => {

				// 			})
				// 		}
				// 	})

				// 	setTimeout(() => {
				// 		this.scanNum = ''
				// 	}, 200)
				let data = this.scanNum.trim().split(' ');
				let arr = [];
				for (let i = 0; i < data.length; i++) {

					this.setPackagedCopy({ orderId: data[i], userId: this.userId, sensitive: this.modelType }).then(res => {
						if (res.code === 1500) {
							console.log(res)
							// this.logisticsOption = res.data.rules
							// this.dialogVisible = true
							arr.push({
								logisticsOption: res.data.rules,
								shopId: res.data.order.shopId,
								storeId: res.data.order.storeId,
								orderId: res.data.order.orderId,
								msgToStore: res.data.order.msgToStore ? res.data.order.msgToStore : this.$t("processed.remarkspresent"),
								ruleId: Number(res.data.order.messageToSeller),
								userId: this.userId,
								height: null,
								length: null,
								weight: null,
								width: null,
								actualCost: null,
								imgUrls: null,
								trackingNo: null,
							})
						} else {
							this.$confirm(res.msg + this.$t("processed.details"), this.$t("processed.hint"), {
								confirmButtonText: this.$t("processed.Isee"),
								type: 'warning'
							}).then(() => {

							})
						}
						if (i == data.length - 1 && arr.length > 0) {
							this.DxsObjParams.items = arr;
							this.dialogVisible = true;
						}
					})

					setTimeout(() => {
						this.scanNum = ''
					}, 200)

				}


			}
		},


		//扫描枪调用的方法
		packBageOut() {
			if (this.scanNum) {
				if (this.shopee) {
					this.setPackaged({ orderId: this.scanNum })
					setTimeout(() => {
						this.scanNum = ''
					}, 200)
				} else {
					this.setPackaged({ orderId: this.scanNum })
					setTimeout(() => {
						this.scanNum = ''
					}, 200)
				}

			} else {

				return
			}
		},
		hfkf() {
			this.packTime = utils.getCurrnetTime(new Date())
			this.shopee = JSON.parse(localStorage.getItem('shopee'))

		},
		handleSizeChange(val) {
			this.offset = Number(`${val}`)
			console.log(this.offset);
		},
		handleCurrentChange(val) {
			this.page = this.offset * (Number(`${val}`) - 1)
			this.getOrdersn({
				offset: this.offset,
				page: this.page,
				shopIds: this.shopIdlist,
				storeIds: this.warehouse,
			})
		},
		handleSelectionChange(val) {
			console.log(val)
			if (val.length === this.choseOrderList.length || val.length === this.orderList2.length) {
				this.chooseAll = true
			} else {
				this.chooseAll = false
			}
			this.multipleSelection = val
			console.log(this.multipleSelection)

		},
	}

}
</script>

<style>
.processedDetail {
	position: absolute;
	width: 100%;
	box-sizing: border-box;
	padding: 0 20px;
	margin-top: 20px;
}

.processedDetail .order-list-item {
	position: relative;
	padding-bottom: 10px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.processedDetail .order-title {

	border-bottom: 1px #E0E0E0 solid;
}

.processedDetail .order-title-count {
	color: red;
	font-style: inherit;
	margin-left: 10px;
}

.processedDetail .order-query {
	display: flex;
	justify-content: start;
	align-items: center;
	padding: 10px;
	border-bottom: 1px #E0E0E0 solid;
}

.el-tooltip__popper.is-dark {
	background: #000000 !important;
}



.processedDetail .order-query .query {
	position: relative;
	margin-right: 30px;
}

.processedDetail .list-btn {
	padding: 20px 15px;
}

.processedDetail .list-desc {
	margin-left: 15px;
	border-bottom: 1px #eee solid;
}

.processedDetail .list-desc-item {
	font-size: 14px;

	padding-right: 15px;
}

.icon-box {
	width: 22px;
	height: 22px;
	cursor: pointer;
	display: inline-block;
}

.icon-box.svg-box:hover {
	color: tomato;
}

.processedDetail .list-item-status {
	color: red;
}

.processedDetail .didan {
	font-size: 24px;
}

.processedDetail .list-content {
	display: flex;
	justify-content: space-around;
	/* margin: 20px;
	padding: 20px; */
	/* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
}

.processedDetail .order-pic {
	width: 80px;
	height: 80px;
}

img {
	width: 100%;
}

.processedDetail .list-content-left,
.list-content-right {
	display: flex;

}

.processedDetail .list-item-wrapper {
	box-sizing: border-box;
	padding: 15px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
}

.processedDetail .order-selec {
	width: 150px;
	margin: 0 10px;
}

.processedDetail .block-ttp {
	width: 350px !important;
}

.processedDetail .order-desc {
	width: 30%;
}

.processedDetail .order-title-desc {
	margin-bottom: 15px;
}

.stroeVisble .el-input__inner {
	width: 99%;
	height: 130px;
	font-size: 30px
}

.processedDetail .list-price-item,
.shoper-name {
	padding: 2px 0;
}

.processedDetail .list-number,
.list-price {
	margin-left: 40px;
}

.list-price-btn {
	display: flex;
	flex-direction: column;
}

.list-price-btn-item {
	margin-top: 20px;
	margin-left: 0 !important;
	width: 120px;
}

.processedDetail .primary-btn {
	display: inline-block;
	margin: 0 30px;
}

.second-menu-wrapper {
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.asb {
	position: relative;
}

.dialog-wrapper {
	display: flex;
	flex-wrap: wrap;
	position: absolute;
	top: 50px;
	left: -600px;
	bottom: 0;
	right: 0;
	width: 600px;
	background-color: #fff;
	margin: 0 auto;
	z-index: 40;
	box-shadow: 0 0 25px #cac6c6;

}

.dialog-wrapper-item {
	display: inline-block;
	width: 100px;
	height: 100px;
	box-sizing: border-box;
	background-color: #fff;
	padding: 5px;
}


.processedDetail .second-menu {
	display: flex;
	justify-content: flex-start;
	position: relative;

}

.processedDetail .menu-right-btn {
	margin-right: 30px;
	color: #606266;
	;
}


.el-icon-loading:before {
	content: "\E6CF";
	font-size: 20px;
}

.notify-boxw {
	width: 330px;
	height: 80px;
	box-shadow: 0 2px 12px 0 rgba(0, 0, 0, .1);
	position: absolute;
	top: 150px;
	right: 30px;
	border-radius: 8px;
	box-sizing: border-box;
	padding: 10px;
	z-index: 999999;
}

.processedDetail .second-menu-left {

	display: flex;
	;

}

.processedDetail .search-box {
	/* 	width: 100px; */
	/* margin: 0 10px 0px 10px; */
}


.processedDetail .sousuo-box {
	width: 300px;
	margin-right: 20px;
}

.processedDetail .chekbox {
	width: 30px;
	height: 30px;
}

.processedDetail .Pager {
	position: fixed;
	bottom: 0;
	left: 235px;
	right: 0;
	height: 40px;
	line-height: 40px;
	background-color: #fff;
	text-align: right;




}

.processedDetail .el-pagination {
	display: flex;
	justify-content: flex-end;
	margin: 0 10px 10px 0;
}

.processedDetail .nodata {
	margin-top: 100px;
	text-align: center;
	color: #000;
}

.processedDetail .checkallbox {
	margin: 7px;
	padding-left: 5px;
	color: #606266;
	font-size: 14px;
	cursor: pointer;

}

.processedDetail .checkallbox:hover {
	color: #409EFF;
}

.processedDetail .checkallbox-oop:hover {
	color: #409EFF;
}

.processedDetail .blank {
	color: #606266;
	text-decoration: none;
}

.processedDetail .createOrder {
	display: flex;
	justify-content: flex-end;
	align-items: center;
	margin-top: 10px;
}

.processedDetail .createOrder-item {
	margin: 0 10px;
}

.processedDetail .el-dropdown-link {
	color: #606266 !important;
}

/* 	.loading-box{
		display: inline-block;
		height: 30px;
	} */

.processedDetail .list-desc {
	display: flex;
	align-items: center;
	margin-left: 5px;
	border-bottom: 1px #eee solid;
	padding: 8px 0;
}

.processedDetail .chekbox {
	width: 30px;
	height: 30px;
	line-height: 30px;
}

.processedDetail .pic-box {
	display: flex;
	margin: 2px;
	width: 80px;
	height: 80px;
}

.processedDetail .return-item {
	display: flex;
	justify-content: space-between;
	box-sizing: border-box;
	padding: 10px;
	font-size: 14px;
}

.processedDetail .return-item-list {
	display: flex;
	align-items: center;

}

.processedDetail .unfold:nth-of-type(n+4) {
	display: none;

}

.processedDetail .pic-box-desc {
	width: 250px;
	margin-left: 20px;
}

.processedDetail .retrun-reasonr {
	margin-left: 30px;
}

.processedDetail .retrun-reasonr-btn {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-right: 20px;
}

.processedDetail .seller {
	margin-right: 10px;
	font-size: 18px;
}

.processedDetail .return-reasonr-desc {
	box-sizing: border-box;
	padding: 3px 0;
}

.processedDetail .seller-item {
	margin-left: 15px;
	font-size: 14px;
}

.processedDetail .seller-ppc {
	color: red;
}

.processedDetail .el-switch__label {
	color: #fff;
}

.ppo {
	display: flex;
	flex-wrap: wrap;
	height: 40px;
	padding: 5px 10px;
	margin: 0px -5px;
	-webkit-box-align: center;
	align-items: center;
	background: #919099;
	color: rgb(255, 255, 255);
	border-top: 10px solid rgb(255, 255, 255);
	border-bottom: 10px solid rgb(255, 255, 255);
	border-radius: 2px;
}

.ppo-item {
	font-size: 14px;
	color: #fff;
	margin-right: 10px;
}







.ordersn-box {
	font-size: 12px;
}

.pic-wrapper {
	display: inline-block;
	width: 40px;
	height: 40px;
	margin-right: 5px;
	position: relative;
}

.pic-wrapper-quantity {
	position: absolute;
	top: 0;
	right: 0;
	display: inline-block;
	width: 15px;
	height: 15px;
	line-height: 15px;
	background-color: red;
	font-size: 8px;
	color: #fff;
	text-align: center;
}

.IdScaneArea .el-input__inner {
	width: 99%;
	height: 130px;
	font-size: 30px
}

.flagbox {
	display: inline-block;
	width: 56px;
	height: 30px;
}

.flagbox .el-radio {
	display: flex;
	align-items: center;
}

.flagbox .el-radio__label {
	padding-left: 5px !important;
}
</style>
